import { Navigate, Outlet } from "react-router";
import { CircularProgress, Container } from "@mui/material";
import useSWR from "swr";
import { swrKey, userFetcher } from "components/userApi";

const LoadingSpinner = () => (
  <Container sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
    <CircularProgress />
  </Container>
);

export const ApprovedUserRoute = () => {
  const { data, isLoading, error } = useSWR(swrKey, userFetcher);

  if (isLoading)
    return <LoadingSpinner />;

  if (error || !data) {
    return <Navigate to="/mypage" replace />;
  }

  if (!data.isApproved) {
    return <Navigate to="/mypage" replace />;
  }

  return <Outlet />;
};

export const DetailRegisterRoute = () => {
  const { data, isLoading, error } = useSWR(swrKey, userFetcher);

  if (isLoading)
    return <LoadingSpinner />;

  if (error || !data) {
    return <Navigate to="/mypage" replace />;
  }

  if (data.isDetailRegistered) {
    return <Navigate to="/mypage" replace />;
  }

  return <Outlet />;
};
